module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Burger-2d24ed235612fea2184ba50c3749d9c3.svg";